export const REMOVE_REPLACE_INGREDIENT_GET_RECIPES_LOADING =
  'REMOVE_REPLACE_INGREDIENT_GET_RECIPES_LOADING';
export const REMOVE_REPLACE_INGREDIENT_GET_RECIPES =
  'REMOVE_REPLACE_INGREDIENT_GET_RECIPES';
export const REMOVE_REPLACE_INGREDIENT_GET_RECIPES_ERROR =
  'REMOVE_REPLACE_INGREDIENT_GET_RECIPES_ERROR';
export const REMOVE_REPLACE_INGREDIENT_CLEAR_RECIPES =
  'REMOVE_REPLACE_INGREDIENT_CLEAR_RECIPES';
export const REMOVE_REPLACE_INGREDIENT_CLEAR_ERRORS =
  'REMOVE_REPLACE_INGREDIENT_CLEAR_ERRORS';
export const REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_LOADING =
  'REMOVE_REPLACE_INGREDIENT_REMOVE_RECIPES_LOADING';
export const REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_ERROR =
  'REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_ERROR';
export const REMOVE_REPLACE_INGREDIENT_SET_SUBMIT_SUCCESS =
  'REMOVE_REPLACE_INGREDIENT_SET_SUBMIT_SUCCESS';
export const REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_ERROR =
  'REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_ERROR';
export const REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_LOADING =
  'REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_LOADING';



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/removereplaceingredient/types.js